import BillingModel from "../../../../../types/billing-model";
import BillingStatus from "../../../../../types/billing-status";

export type BillingsOrderForwardTaxiTaxiRecalculateActionContractTaxiRecalculate =
  {
    displayName: string;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateActionContract = {
  model: BillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  producerTaxi: BillingsOrderForwardTaxiTaxiRecalculateActionContractTaxiRecalculate;
};

export type BillingsOrderForwardTaxiTaxiRecalculateActionTransportingOrderCargoOrder =
  {
    uuid: string;
    humanId: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateActionTransportingOrder = {
  cargoOrder: BillingsOrderForwardTaxiTaxiRecalculateActionTransportingOrderCargoOrder;
};

export type BillingsOrderForwardTaxiTaxiRecalculateAction = {
  uuid: string;
  contract: BillingsOrderForwardTaxiTaxiRecalculateActionContract;
  transportingOrder: BillingsOrderForwardTaxiTaxiRecalculateActionTransportingOrder;
};

export type BillingsOrderForwardTaxiTaxiRecalculateNode = {
  uuid: string;
  nodeUuid: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventUuid: string | null;
  plannedDate: Date | null;
  orderUuid: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  haltingAmount: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsOrderForwardTaxiTaxiRecalculateContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  CHARGE_HIGHWAYS = "CHARGE_HIGHWAY",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsOrderForwardTaxiTaxiRecalculateContributionBonusFavorableDistance =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateContributionBonusOther = {
  type: BillingsOrderForwardTaxiTaxiRecalculateContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsOrderForwardTaxiTaxiRecalculateContributionPenaltyWrongRoute =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateContributionPenaltyBeingLate =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateContributionPenaltyIncompatibleCar =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateContributionPenaltyOther = {
  type: BillingsOrderForwardTaxiTaxiRecalculateContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsOrderForwardTaxiTaxiRecalculateContributionBonus =
  | BillingsOrderForwardTaxiTaxiRecalculateContributionBonusFavorableDistance
  | BillingsOrderForwardTaxiTaxiRecalculateContributionBonusOther;

export type BillingsOrderForwardTaxiTaxiRecalculateContributionPenalty =
  | BillingsOrderForwardTaxiTaxiRecalculateContributionPenaltyWrongRoute
  | BillingsOrderForwardTaxiTaxiRecalculateContributionPenaltyBeingLate
  | BillingsOrderForwardTaxiTaxiRecalculateContributionPenaltyIncompatibleCar
  | BillingsOrderForwardTaxiTaxiRecalculateContributionPenaltyOther;

export type BillingsOrderForwardTaxiTaxiRecalculateContribution =
  | BillingsOrderForwardTaxiTaxiRecalculateContributionBonus
  | BillingsOrderForwardTaxiTaxiRecalculateContributionPenalty;

type BillingsOrderForwardTaxiTaxiRecalculate = {
  orderForwardingAction: BillingsOrderForwardTaxiTaxiRecalculateAction;
  billingNodes: BillingsOrderForwardTaxiTaxiRecalculateNode[];
  billingContributions: BillingsOrderForwardTaxiTaxiRecalculateContribution[];
  allContributionsAmount: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  distance: number;
  amountForDistance: number;
  planEntryUuid: string;
  sumOfBonuses: number;
  sumOfPenalties: number;
  date: Date;
  status: BillingStatus;
  passengers: string[];
};

export default BillingsOrderForwardTaxiTaxiRecalculate;
